import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/factors/dimensions'

const getDimensiones = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const crearDimension = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarDimension = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarDimension = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getDimensiones,
  crearDimension,
  eliminarDimension,
  actualizarDimension,
}
